// react
import React, { Component } from 'react'

// dependencies
import papa from 'papaparse'

// css
import '../../css/pages/DataExplore.styl'

// components
import Header from '_components/header/index.jsx'
import SyntheticUsersBoard from '../components/SyntheticUsersBoard.jsx'
import SyntheticUsersQueryPane from '../components/SyntheticUsersQueryPane.jsx'

// lib
import downloadCSV from '../lib/downloadCSV.js'

// DataExplore Page
class DataExplorerSyntheticUsers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      table_data: null,
      selected_attributes: null,
    }
  }

  onChangeTableData = (data) => {
    this.setState({ table_data: data })
  }

  onChangeSelectedAttributes = (data) => {
    this.setState({ selected_attributes: data })
  }

  downloadCSV = () => {
    let { table_data } = this.state

    // do some validation
    if (!table_data) return
    if (!table_data.rows) return
    if (!table_data.rows.length) return
    if (!table_data.columns) return
    if (!table_data.columns.length) return

    let rows = []
    for (let [index, row] of table_data.rows.entries()) {
      rows[index] = []
      for (let column of table_data.columns) {
        let value = row[column]
        if (value === undefined) value = ''
        rows[index].push(value)
      }
    }

    let csv = papa.unparse({
      fields: table_data.columns,
      data: rows,
    })

    downloadCSV(csv, 'data-explorer-insights')
  }

  render() {
    let { table_data, selected_attributes } = this.state
    return (
      <div id="data-explore-page">
        <Header
          title="Data Explorer for Synthetic Users"
          actions={[
            {
              children: 'Download',
              onClick: this.downloadCSV,
            },
          ]}
        />

        <div className="data-explore-container">
          <SyntheticUsersQueryPane
            onChangeTableData={this.onChangeTableData}
            onChangeSelectedAttributes={this.onChangeSelectedAttributes}
          />
          <SyntheticUsersBoard table_data={table_data} selected_attributes={selected_attributes} />
        </div>
      </div>
    )
  }
}

// export
export default DataExplorerSyntheticUsers
